import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { APIS, BASE, URLS, SF_REGN_CD_INFO } from "@/tz/go/egaz/osci/ptl/cd/regncd/services/OsciRegnCdService";

/*
 * Region Code Registration
 * !== 지역 코드 등록 ==!
 */
export const OSCI0109013S = () => {
    useResource({
        defaultSchema: [
            { area: "cntyCd" },
            { area: "comnCd", comnCd: "OSC0091" },
            { area: "comnCd", comnCd: "OSC0101" }, // 활성화 여부 코드
        ],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { t } = useTranslation();

    const form = {
        regnCdInfo: useForm({
            defaultSchema: SF_REGN_CD_INFO,
        }),
    };

    const fetch = {
        insertRegnCdInfo: useFetch({
            api: (data: any) => APIS.insertRegnCdInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        navigate(`${URLS.osci0109012q}?menuId=${menuId}`);
                    },
                });
            },
            onError: (data) => {
                modal.openModal({ content: data.response.data.errorMessage }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                // toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
    };

    const handler = {
        onRestBtnClick: () => {
            handler.clearFormState();
            form.regnCdInfo.reset();
        },
        onListBtnClick: () => {
            navigate(URLS.osci0109012q);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.regnCdInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.regnCdInfo.handleSubmit(
                () => {
                    const data = form.regnCdInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertRegnCdInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.regnCdInfo.errors), form.regnCdInfo.isSubmitted);
                },
            )();
        },
        clearFormState: () => {
            form.regnCdInfo.clearErrors();
            form.regnCdInfo.resetSchema();
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnCd} />
                            <Group.Control {...form.regnCdInfo.schema.regnTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.cntyCd} />
                            <Group.Control {...form.regnCdInfo.schema.cstmOfceCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnNmEn} />
                            <Group.Control {...form.regnCdInfo.schema.regnNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnNmTz} />
                            <Group.Control {...form.regnCdInfo.schema.portYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
